// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"3fe13009","359":"9118f982","361":"17db8977","511":"b9b14af9"}[chunkId] + ".chunk.js";
};